(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alteire-complete-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alteire-complete-look')) {
    customElements.define('alteire-complete-look', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-size]');
        this.button = this.querySelector('button[type="submit"]');
        this.error = this.querySelector('[data-error-message]');
        this.select.addEventListener('change', () => this.updatePrice());
        this.form.addEventListener('submit', (event) => this.addSet(event));
        this.updatePrice();
      }
      updatePrice() {
        const option = this.select.selectedOptions[0];
        if (!option) return;
        this.querySelector('[data-primary-price]').textContent = option.dataset.primary;
        this.querySelector('[data-original-price]').textContent = option.dataset.original;
        this.querySelector('[data-set-price]').textContent = option.dataset.price;
        this.querySelector('span[data-discount]').textContent = option.dataset.discount + '%';
        this.querySelector('.alteire-set__badge').hidden = Number(option.dataset.discount) <= 0;
        this.button.disabled = option.disabled || this.busy;
      }
      async addSet(event) {
        event.preventDefault();
        if (this.busy || this.button.disabled) return;
        // Disabled form controls are omitted by FormData; capture the selected bundle first.
        const variantId = this.select.value;
        const quantity = Number(this.form.elements.quantity.value) || 1;
        if (!variantId) {
          this.error.textContent = this.dataset.error;
          this.error.hidden = false;
          return;
        }
        this.busy = true;
        this.button.disabled = true;
        this.select.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.button.textContent = this.button.dataset.loadingLabel;
        this.error.hidden = true;
        let deferred;
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const sections = [...new Set(
            [...document.querySelectorAll('cart-items-component[data-section-id]')]
              .map(element => element.dataset.sectionId)
          )].slice(0, 5);
          const oldCount = Number(document.querySelector('[ref="cartItemCount"]')?.textContent) || 0;
          deferred = CartLinesUpdateEvent.createPromise();
          deferred.promise.catch(() => {});
          this.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise
          }));
          const response = await fetch(this.form.action + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          let ajaxCart;
          try {
            const cartResponse = await fetch(this.dataset.cartUrl + '.js', {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            });
            if (cartResponse.ok) ajaxCart = await cartResponse.json();
          } catch {}
          const sectionDocument = new DOMParser().parseFromString(
            result.sections?.['cart-drawer-section'] || '', 'text/html'
          );
          const renderedCount = sectionDocument.querySelector('[ref="cartItemCount"]')?.textContent;
          const itemCount = ajaxCart?.item_count ?? (renderedCount ? Number(renderedCount) : oldCount + quantity);
          deferred.resolve({
            ...(ajaxCart ? { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart) } : {}),
            detail: {
              sections: result.sections,
              items: ajaxCart?.items,
              itemCount,
              didError: false,
              source: 'alteire-complete-look'
            }
          });
        } catch (error) {
          deferred?.reject(error);
          this.error.textContent = error.message || this.dataset.error;
          this.error.hidden = false;
        } finally {
          this.busy = false;
          this.select.disabled = false;
          this.button.removeAttribute('aria-busy');
          this.button.textContent = this.button.dataset.addLabel;
          this.updatePrice();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alteire-footer"] && !Shopify.designMode) return;
  try {
    
function setupAlteireFooters() {
  document.querySelectorAll('.af').forEach(footer => {
    if (footer.dataset.ready) return;
    footer.dataset.ready = 'true';
    const media = window.matchMedia('(min-width:750px)');
    const sync = () => footer.querySelectorAll('.af__panel').forEach(panel => {
      panel.open = media.matches || !!panel.querySelector('[data-af-status]');
    });
    sync();
    media.addEventListener('change', sync);
    footer.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', event => {
      if (media.matches) event.preventDefault();
    }));
  });
}
setupAlteireFooters();
document.addEventListener('shopify:section:load', setupAlteireFooters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alteire-review-summary"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alteire-review-summary')) {
    customElements.define('alteire-review-summary', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.track = this.querySelector('.alteire-reviews__track');
        this.controls = this.querySelector('.alteire-reviews__controls');
        if (!this.track || !this.controls) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-direction]');
          if (button) this.move(Number(button.dataset.direction));
        }, { signal });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = Array.from(this.track.children).find((item) => item.dataset.reviewId === event.detail?.blockId);
          if (!card) return;
          const left = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
          this.track.scrollTo({ left, behavior: 'auto' });
        }, { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.update(), { signal });
        }
        this.update();
      }

      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 12;
        const step = card.getBoundingClientRect().width + gap;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maximum <= 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
        const scrollbar = this.querySelector('.alteire-reviews__scrollbar');
        if (scrollbar) {
          scrollbar.hidden = maximum <= 2;
          const total = this.track.scrollWidth || 1;
          const position = Math.max(0, Math.min(maximum, this.track.scrollLeft));
          this.style.setProperty('--review-thumb-width', `${Math.min(100, this.track.clientWidth / total * 100)}%`);
          this.style.setProperty('--review-thumb-left', `${position / total * 100}%`);
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alteire-trust-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alteire-trust-banner')) {
    customElements.define('alteire-trust-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.played || this.dataset.animate !== 'true' || !('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.played = true;
          this.observer.disconnect();
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.animations = Array.from(this.querySelectorAll('.alteire-trust__icon'), (icon, index) => {
            if (typeof icon.animate !== 'function') return null;
            return icon.animate([
              { opacity: 0, transform: 'translateY(14px) scale(0.92)' },
              { opacity: 1, transform: 'translateY(0) scale(1)' }
            ], {
              duration: 680,
              delay: index * 120,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'backwards'
            });
          });
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.animations?.forEach((animation) => animation?.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
